import React from 'react';
import ReactApexChart from 'react-apexcharts';

const LineChartTM = ({ graphData }) => {
  // Extract the Cost_per_case_cy data and categories (year_week_cy)
  const costData = graphData.map(item => item.Cost_per_case_cy || 0);
  const categories = graphData.map(item => item.year_week_cy || 'N/A');

  const options = {
    series: [
      {
        name: 'Cost per Case',
        type: 'line',
        data: costData,
      },
    ],
    chart: {
      toolbar: {
        show: false
      },
      type: 'line',
      height: 500,
    },
    stroke: {
      width: 2.5,
      colors: ['#01B2AA'],
      curve: "straight",
    },
    grid: {
      show: false,
      borderColor: '#e7e7e7',
      strokeDashArray: 0,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: true,
          borderColor: '#000000',
          strokeWidth: 2
        }
      }
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      crosshairs: {
        show: true,
      }
    },
    fill: {
      opacity: 1
    },
    colors: ['#01B2AA'],
    yaxis: {
      labels: {
        formatter: (val) => {
          return '$' + val.toFixed(2);
        }
      },
      axisBorder: {
        show: false,
      },
      forceNiceScale: true,
      title: {
        text: 'Cost per Case ($)',
        style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 500,
          color: "#333"
        }
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      markers: {
        width: 12,
        height: 12,
        radius: 10,
      },
    }
  };

  return (
    <div className="grouped-bar-line-chart">
      <ReactApexChart options={options} series={options.series} type="line" height={400} />
    </div>
  );
};

export default LineChartTM;